import React from 'react'
import styled from 'styled-components'

const ProgressBarContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  height: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  direction: ltr;
  background-color: #e1e1e1;
`

const ProgressBarFill = styled.div`
  height: 100%;
  background-color: #9a1318;
  width: ${(props: { progress: number }) => props.progress}%;
`

interface ProgressBarProps {
  progress: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarFill progress={progress} />
    </ProgressBarContainer>
  )
}

export { ProgressBar }
